export type SessionStorageKey = string;

export class SessionStorage {
  static hasIsMapVisible(): boolean {
    return this.has('isMapVisible');
  }

  static setIsMapVisible(isVisible: boolean) {
    this.set('isMapVisible', JSON.stringify(isVisible));
  }

  static getIsMapVisible(): boolean {
    if (this.has('isMapVisible')) {
      const isMapVisible = this.get('isMapVisible');
      return JSON.parse(isMapVisible as string);
    }
    return true;
  }

  private static has(key: SessionStorageKey): boolean {
    return sessionStorage.getItem(key) !== null;
  }

  private static set(key: SessionStorageKey, value: string) {
    sessionStorage.setItem(key, value);
  }

  private static get(key: SessionStorageKey): string | null {
    return sessionStorage.getItem(key);
  }
}
